import React, { useEffect, useState } from "react";
import Scrollbar from "../../scrollbar";
import { MdDeleteOutline, MdEdit } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../utils/redux/hooks";
import { addagents, addisLoading, viewAgent } from "../../../utils/redux/mainSlice";
import { deleteAgent, getAgents, getChat } from "../../../utils/apis/func";
import { RootState } from "../../../utils/redux/store";
import { Dialog, DialogBody, DialogHeader } from "@material-tailwind/react";
import { toast } from "react-toastify";

const ManageAgent = () => {
  const agents = useAppSelector((store: RootState) => store.user?.agents);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalItems = agents?.length;

  console.log("--------agents", agents);

  const allItems = Array.from({ length: itemsPerPage }, (_, index) => ({
    id: index + 1,
    name: `First Last ${index + 1}`,
    phoneNumber: `0805214256${index}`,
    email: `example${index}@example.com`,
    dob: `12/02/1991`,
    address: `250`,
  }));

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  //   const data = { endIndex, allItems };
  //   console.log(data);

  const itemsToShow = agents?.slice(startIndex, endIndex);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    const fetchAgents = async () => {
      dispatch(addisLoading(true));
      const res: any = await getAgents("");
      console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addagents(res?.data?.data));
      }

      dispatch(addisLoading(false));
    };

    fetchAgents();
  }, [dispatch]);

  const [open, setOpen] = React.useState(false);
  const [selectedID, setSelectedID] = useState("");
  const handleOpen = () => setOpen(!open);

  const navigate = useNavigate();

  const handleDeleteAgent = async () => {
    console.log(selectedID);
    // setisLoading(true);
    dispatch(addisLoading(true));
    const res: any = await deleteAgent(selectedID);
    console.log(res);
    if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
      toast("Agent Deleted Successfully, reload page", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate("/agents");
    }
    dispatch(addisLoading(false));
    setOpen(false);
    // window.location.reload();
  };

  const handleProceed = () => {
    console.log("Selected id", selectedID);
  };

  return (
    <>
      <div className="overflow-x-auto rounded-t-lg mt-6 ">
        <table className="text-sm  text-gray-500 dark:text-gray-400 px-3 text-center w-full">
          <thead className=" bg-[#88087B]  py-8 px-10 text-[#F7F7F7] font-roboto text-lg font-medium leading-normal rounded-t-lg ">
            <tr>
              <th scope="col" className="px-6 py-3">
                Name
              </th>
              <th scope="col" className="px-6 py-3">
                Phone Number
              </th>
              <th scope="col" className="px-6 py-3">
                Email
              </th>
              <th scope="col" className="px-6 py-3">
                DoB
              </th>

              <th scope="col" className="px-6 py-3">
                Address
              </th>
              <th scope="col" className="border-none py-3"></th>
              <th scope="col" className="border-none py-3"></th>
            </tr>
          </thead>
          <tbody>
            {itemsToShow?.map((item, index) => (
              <tr className=" py-4 px-20 hover:bg-[#87878d] text-black transition duration-300 font-roboto text-xs font-medium leading-normal items-center">
                <td className="px-6 py-4">
                  {" "}
                  {item?.firstName} {item?.lastName}
                </td>
                <td className="px-6 py-4"> {item?.phoneNumber}</td>
                <td className="px-6 py-4"> {item?.email}</td>
                <td className="px-6 py-4"> {item?.dob?.slice(0, 10)}</td>
                <td className="px-6 py-4">{item?.address}</td>
                <td className="" onClick={()=>{
                  dispatch(viewAgent(item));
                }}>
                  <Link to={`/agents/edit/${item?.id}`}>
                    {/* <Link to={`/agents/edit/${index}`}> */}
                    <MdEdit size={18} className=" cursor-pointer" />
                  </Link>
                </td>
                <td className="">
                  <MdDeleteOutline
                    onClick={() => {
                      setOpen(true);
                      setSelectedID(item?.id || item?._id);
                    }}
                    size={25}
                    className=" cursor-pointer text-[#fff] bg-[#D11C1C] rounded-md p-0.5"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Scrollbar
        currentPage={currentPage}
        totalPages={Math.ceil(totalItems / itemsPerPage)}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPrevPageClick={handlePrevPageClick}
        onNextPageClick={handleNextPageClick}
      />

      <Dialog open={open} handler={handleOpen}>
        <DialogHeader>Delete Agent</DialogHeader>
        <DialogBody>
          <div className="relative p-4 w-full  max-h-full flex  flex-col">
            <div className="p-4 md:p-5 text-center mx-auto ">
              <svg
                className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to delete Agent?
              </h3>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2"
                onClick={handleDeleteAgent}
              >
                Proceed
              </button>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-gray-500 ml-4 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                onClick={() => {
                  // close();
                  setOpen(false);
                }}
              >
                No, cancel
              </button>
              {/* {isLoading && (
                <>
                  <Dots size={40} color="var(--admin-accent)" />
                </>
              )} */}
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default ManageAgent;
